
export default {
    state: {
        userData: JSON.parse(localStorage.getItem("userData")) || {},
        authtoken: localStorage.getItem("authtoken")
    },
    getters: {
        authtoken: state => state.authtoken,
        userId: (state) => state.userData._id,
        realname: (state) => state.userData.realname,
        avatarurl: (state) => state.userData.avatarurl,
        userType: (state) => state.userData.user_type,
        mobile: (state) => state.userData.mobile
    },
    mutations: {
        updateUserData (state, userData) {
            state.userData = userData || {};
            localStorage.setItem("userData", JSON.stringify(userData));
        },
        updateAuthtoken (state, authtoken) {
            state.authtoken = authtoken;
            localStorage.setItem("authtoken", authtoken);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js